import Swiper, { Navigation, Pagination, Autoplay, Controller, EffectFade } from 'swiper';

let gallerySwiper = document.querySelector('.swiper--gallery');
if (gallerySwiper) {
  let pagination = gallerySwiper.parentElement.querySelector('.swiper-pagination');
  let navPrev = gallerySwiper.parentElement.querySelector('.swiper-nav--prev');
  let navNext = gallerySwiper.parentElement.querySelector('.swiper-nav--next');
  new Swiper(gallerySwiper, {
    modules: [ Navigation, Pagination, Autoplay ],
    speed: 600,
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: navNext,
      prevEl: navPrev,
      disabledClass: 'is-disabled',
    },
    pagination: {
      el: pagination,
      type: 'bullets',
      bulletClass: 'swiper-pagination__bullet',
      bulletActiveClass: 'current',
      clickable: true,
      renderBullet: function(index, className) {
        let url = this.slides[index].dataset.url;
        // console.log(url);
        return `<div class="${className}"><img class="${className}__img" src="${url}"/></div>`;
      },
    },
    autoplay: {
      delay: 8000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    on: {
      init: function() {
        dynamicPagination(this.pagination, this.realIndex);
        
        this.el.addEventListener('focusin', event => {
          // console.log(this.slides.length);
          this.slides.forEach((slide, index) => {
            if (slide.contains(event.target)){
              // console.log(index);
              this.slideTo(index, this.speed);
            }
          });
        });
      },
      afterInit: function () {
        document.dispatchEvent(new CustomEvent('swiperReady'));
      },
      resize: function() {
        dynamicPagination(this.pagination, this.realIndex);
      },
      slideChange: function() {
        dynamicPagination(this.pagination, this.realIndex);
      },
    }
  });
}

function dynamicPagination(pagination, activeIndex) {
  const spacing = 20;
  let paginationWidth = pagination.el.offsetWidth;
  let bulletWidth = pagination.bullets[0].offsetWidth;
  // console.log(bulletWidth);
  let spacedBulletWidth = bulletWidth + spacing;
  let offset = -5; // move 2px right to fit outline with its offset
  // let offset = 0;

  if (spacedBulletWidth * activeIndex > paginationWidth / 2) {
    offset = spacedBulletWidth * activeIndex - paginationWidth / 2 + bulletWidth / 2;

    let paginationContentWidth = spacedBulletWidth * pagination.bullets.length - spacing;
    if (offset > paginationContentWidth - paginationWidth) {
      offset = paginationContentWidth - paginationWidth;
    }
  }

  pagination.bullets.forEach(bullet => {
    bullet.style['transform'] = `translateX(${offset * -1}px)`;
  });
}
